export default __webpack_public_path__ + "static/media/icon-question.27f834e1.svg";